import React from "react";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { Button } from "react-bootstrap";
import { Price } from "./Price";

const strings = getStrings().component.common;

export const BookingFooter = (props: {
	text?: string,
	onSubmit?: Function,
	submitButton?: React.ReactElement,
	backText?: string,
	onBack?: Function,
	priceText?: string,
	price?: number }) => {

	function handleSubmit() {
		if (props.onSubmit)
			props.onSubmit();
	}

	function handleBack() {
		if (props.onBack)
			props.onBack();
	}

	return <div className="footer">
		<span className="back">
			{props.backText ? <Button variant="secondary" type="button" disabled={!props.onBack} onClick={handleBack}>{props.backText}</Button> : null}
		</span>
		<span className="price">
			<JourneyPrice text={props.priceText} price={props.price} />
		</span>
		<span className="submit">
			{ props.submitButton ||
			<Button variant="primary" type="button" disabled={!props.onSubmit} onClick={handleSubmit}>{props.text}</Button>}
		</span>
	</div>;
}

const JourneyPrice = (props: { text?: string, price?: number }) => {
	return (
		props.price != null
		? <span>{props.text || strings.totalPrice}: <span className="totalPrice"><Price amount={props.price} /></span></span>
		: null
	);
}